import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import { PRIVACY_POLICY_URL } from '../../../utils/accountConsent'
import './styles.css'

// SPEC-101 D9: the small pieces every auth screen shares, so the login,
// register, checkout and code screens read the same.

// The small centred title, the same size as checkout's "Create your account"
export const AuthTitle = ({ children }) => (
  <h1 className="AuthParts__title">{children}</h1>
)

AuthTitle.propTypes = { children: PropTypes.node.isRequired }

// "New here? Create an account" / "Already have an account? Log in"
export const AuthFooter = ({ children }) => (
  <p className="AuthParts__footer">{children}</p>
)

AuthFooter.propTypes = { children: PropTypes.node.isRequired }

export const OrDivider = () => (
  <div className="AuthParts__or">
    <span>or</span>
  </div>
)

// Where an account can be created: one line covering every option
export const TermsLine = () => (
  <p className="AuthParts__terms">
    By continuing with email, Google, Apple or Facebook, you agree to our{' '}
    <Link to="/customer-care/terms-of-use" target="_blank">
      Terms and Conditions
    </Link>{' '}
    and have read the{' '}
    <Link to="/customer-care/warnings-and-risks" target="_blank">
      Warnings and Risks
    </Link>{' '}
    and{' '}
    <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    .
  </p>
)
